export default __webpack_public_path__ + "static/media/notification.28186e5d.svg";